let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("92vLy")).then(() => parcelRequire('5lALU'));